import logoCDR from "@assets/events-awards/sca/logo-cdr.jpg";
import logoDeloitte from "@assets/events-awards/sca/logo-deloite.png";
import logoEY from "@assets/events-awards/sca/logo-ey.png";
import logoHedrikStruggles from "@assets/events-awards/sca/logo-heidrick-struggles.png";
import logoKPMG from "@assets/events-awards/sca/logo-kpmg.png";
import logoNUS from "@assets/events-awards/sca/logo-nus.png";
import logoPWC from "@assets/events-awards/sca/logo-pwc.svg";
import Container from "@src/app/components/Container/Container";

/**
 * Component to render Partners Details Section
 */
const PartnersDetails = (): React.ReactElement => {
  return (
    <div data-testid="partners-details-component" className="mb-12">
      <Container>
        <div className="flex flex-col items-center justify-center lg:flex-row lg:items-start">
          <div className="lg:w-4/5">
            <p className="text-center text-2xl">Award Partners</p>

            <div className="grid grid-cols-1 justify-items-center lg:grid-cols-3">
              <img
                src={logoDeloitte}
                width={120}
                height={32}
                alt="Deloitte logo"
                className="my-6 lg:mt-auto"
              />

              <img
                src={logoEY}
                width={143}
                height={65}
                alt="EY logo"
                className="my-6 lg:mt-auto"
              />

              <img
                src={logoHedrikStruggles}
                width={225}
                height={13}
                alt="Hedrik and Struggles logo"
                className="my-6 lg:mt-auto"
              />

              <img
                src={logoKPMG}
                width={100}
                height={56}
                alt="KPMG logo"
                className="my-6 mt-10"
              />

              <img
                src={logoNUS}
                width={300}
                height={43}
                alt="NUS logo"
                className="my-6 lg:mt-auto"
              />

              <img
                src={logoPWC}
                width={100}
                height={100}
                alt="PWC logo"
                className="my-6 lg:mt-auto"
              />
            </div>
          </div>

          <div className="flex flex-col items-center md:ml-4 lg:w-1/5">
            <p className="text-2xl">Supporting Partners</p>

            <img
              src={logoCDR}
              width={108}
              height={43}
              alt="CDR logo"
              className="my-6 mt-10"
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default PartnersDetails;
